Vue.component 'contech-carousel',
    template: "#carousel"
    props:
        ## class name of individual slides
        ## will be used to count them and get
        ## their dimensions
        slideClass: default: '.slide'
        gap: # distance between slides
            type:    Number or String
            default: 20 # 20px by default
        ## extra dot is needed for carousels
        ## where several slides are contained
        ## in a visible frame
        extraDot: type: Boolean

    data: ->
        ## number of dots can change during init
        ## so hide it until init is finished
        dotsShown:   false
        slideWidth:  0 # slide size without the gap
        holderWidth: 0 # slide holder size in pixels
        leftShift:   0 # how much the slides shifted to the left
        maxShift:    0 # how much to the left slides can shift
        count:       0 # number of slides in the carousel

    mounted: ->
        @reel = @$el.querySelector ".reel"
        window.addEventListener "load",   @init
        window.addEventListener "resize", @init

        startX = 0
        getTouchX = (e)-> e.changedTouches[0].screenX

        @reel.addEventListener 'touchstart', (e)-> startX = getTouchX e
        @reel.addEventListener 'touchend',   (e)=>
            endX = getTouchX e
            diff = endX - startX
            return if Math.abs(diff) < 100
            if diff < 0
                do @showNext
            else do @showPrev

    computed:
        ## slide size including the gap
        ## gap size is only relevant during overflow
        minSlideWidth: -> @slideWidth + @gap

        ## number of whole slides that the holder can fit in
        wholeSlides: -> Math.floor @holderWidth / @minSlideWidth

        ## number of nav dots below the slides (+ 0th position)
        dotsNum: ->
            num = @count - @wholeSlides + if @extraDot then 1 else 0
            Math.max num, 0

        ## do we show nav arrows? (yes if slides exceed holder size)
        navShown: -> (@count * @minSlideWidth - @gap) > @holderWidth

        cantGoNext: -> @leftShift <= @maxShift

        cantGoPrev: -> @leftShift >= 0

    methods:
        init: ->
            ## reset all size data
            @slideWidth = @holderWidth = @leftShift = @maxShift = 0

            ## recalculate the number of slides
            @count = @reel.querySelectorAll(@slideClass).length

            ## read element sizes
            @holderWidth = (@getRect ".holder").width
            @slideWidth  = (@getRect @slideClass).width

            ## set up maximum possible shift
            @maxShift  = @holderWidth - (@minSlideWidth * @count - @gap)
            @dotsShown = true

        initAfter: (delay = 200)-> setTimeout @init, delay

        ## get size of a sub element in the component
        getRect: (selector)->
            if not el = @[selector]
                el = @[selector] =  @$el.querySelector selector
            el.getBoundingClientRect()

        showNext: -> # show next slide
            return if @cantGoNext
            @leftShift -= @minSlideWidth

        showPrev: -> # show prev slide
            return if @cantGoPrev
            @leftShift += @minSlideWidth

        ## shift to a position designated by a dot (i starts at 1 rather than 0)
        shiftTo: (i)-> @leftShift = -@minSlideWidth * i

        ## is the nav dot selected
        isDotSelected: (i)-> i is -@leftShift / @minSlideWidth


Vue.component 'our-team',
    template: "#our-team"
    props:
        showFilters: type: Boolean

    data: ->
        department: ''
        teamSlides: @$parent.team_slides.slides
        depts:      @$parent.team_slides.departments

    computed:
        slides: ->
            return @teamSlides if not @department
            @teamSlides.filter (s)=> s.dept is @department

    watch:
        slides: -> do @$refs.carousel.initAfter if @$refs.carousel

    methods:
        setDept: (name)->
            if name is @department
                name = ''
            @department = name

        isSelected: (name)-> name is @department

randomString = (size = 12)->
    chars = "1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM"
    pass = []
    for j in [0...size]
        pos = Math.floor(Math.random() * chars.length)
        pass.push chars[pos]
    pass.join ''

catsPopupMixin =
    data: ->
        selected: '' # selected cat name
        popupName: 'product-cats-' + randomString()

    computed:
        ## is the category selector shown
        catsShown: -> @$root.popup is @popupName

    methods:
        ## show category selector popup
        showCats: -> @$root.showPopup @popupName

Vue.component 'featured-products',
    template: "#featured-products"
    mixins: [catsPopupMixin]
    props:
        category:    default: ''
        showFilters: type: Boolean
        sustainable: type: Boolean

    data: ->
        productSlides: @$parent.product_slides

    computed:
        filteredProds: ->
            prods = @productSlides
            if c = @category
                prods = prods.filter (p)-> p.category is c
            return prods if not @sustainable
            prods.filter (p)-> p.sustainable

        products: ->
            num   = 10 # max number of slides
            prods = @filteredProds
            if @selected
                prods = prods.filter (p)=> p.category is @selected
            len = prods.length
            if len > num
                prods = prods.slice len - num
            prods

    watch:
        products: -> do @$refs.carousel.initAfter if @$refs.carousel

Vue.component 'product-showcase',
    template: "#product-showcase"
    data: ->
        productShowcase: @$parent.product_showcase

Vue.component 'html-carousel',
    template: "#html-carousel"

    mounted: ->
        ## extract 4 columns from html
        ## and place them into carousel
        reel = @$el.querySelector ".reel"
        four = document.querySelector ".four-icons"
        cont = four.querySelector ".icons"
        cols = cont.querySelectorAll ".wp-block-column"
        reel.replaceChildren cols...
        four.removeChild cont

Vue.component 'category-listing',
    template: "#category-listing"
    props:
        products: type: Array
        value: type: String # selected category

    data: ->
        cats: @$root.product_cats # product cats list

    computed:
        selected:
            get:      -> @value
            set: (val)-> @$emit 'input', val

    methods:
        setCat: (name)-> # set selected cat
            if name is @selected
                name = ''
            @selected = name

        ## is cat selected
        isSelected: (name)-> name is @selected

        ## count products in a cat
        countProds: (catName)->
            count = 0
            count++ for p in @products when p.category is catName
            count

Vue.component 'product-search',
    mixins: [catsPopupMixin]
    template: "#product-search"
    props: downloads: type: Boolean

    data: ->
        filter:   '' # product listing filter string
        products: @$parent.product_slides # product list

    computed:
        filteredProducts: ->
            return @products if not @downloads
            @products.filter (p)-> p.downloads.length

        productCat: -> # filter products by selected cat
            return @products if not @selected
            @products.filter (p)=> p.category is @selected

        filteredProds: -> # product listing after applying filter
            trimmed = @filter.trim().toLowerCase()
            return @productCat if trimmed.length < 3
            @productCat.filter (p)-> p.filter.includes trimmed

        noProds: -> @filteredProds.length is 0

Vue.component 'product-pane',
    template: "#product-pane"

    data: ->
        selected: '' # selected category
        cats:     @$root.product_cats
        allProds: @$root.product_slides

    computed:
        label: ->
            return 'Products' if not @selected
            @selected

        catClass: -> if @label.length > 12 then 'small' else ''

        products: ->
            return @allProds if not @selected
            @allProds.filter (p)=> p.category is @selected

        mobileShown: -> @$root.mobileShown

    methods:
        goBack: ->
            return @$root.toggleProducts() if not @selected
            @selected = ''
            

devContactForm =
    firstName:  'Tester'
    secondName: 'Testerson'
    email:      'test@test.com'
    phone:      '123123456'
    message:    "This is a test message.\n\nThank you."

liveContactForm =
    firstName:  ''
    secondName: ''
    email:      ''
    phone:      ''
    message:    ''

Vue.component 'contact-form',
    template: "#contact-form"

    data: ->
        sent:    false # form has been sent
        sending: false # form is being sent
        error:   false # there was a submission error

        form: if isLive then liveContactForm else devContactForm

        nameError:    false
        emailError:   false
        messageError: false

    methods:
        emailValid: (email)->
            re = /\S+@\S+\.\S+/
            re.test email

        send: ->
            @emailError   = not @emailValid @form.email
            @nameError    = not @form.firstName.trim()
            @messageError = not @form.message.trim()
            return if @emailError or @nameError or @messageError

            @sending = true
            ok    = => @sent = true
            notok = => @error = true
            done  = => @sending = false

            wpAjaxData 'save_email_lead', @form, ok, notok, done

Vue.component 'wait-button',
    template: """
<button :disabled='disabled || wait'
        @click='$emit("click")'
        class='wait-button-component'
        :class="{wait: wait}">
    <slot></slot>
    <img class='spinner'
         alt="Wait spinner"
         src="#{themeUrl}/img/icons/spinner-white.svg" />
</button>
"""
    props:
        wait:       Boolean
        disabled:   Boolean

Vue.component 'blurred-circle',
    template: """
<div class='blurred-circle-component'
     :style='sizes'>
    <canvas :width='size'
            :height='size'
            :style='canvStyle'
            ref='canvas'></canvas>
</div>
"""
    props:
        size:   default: 600
        colour: default: 'orange'
        left:   default: '10%'
        bottom: default: '25%'

        fromX: default: -20
        tillX: default:  90
        fromY: default:  25
        tillY: default:  30

    data: ->
        x: @left
        y: @bottom
        canvX: "0px"
        canvY: "0px"
        bg: "#{themeUrl}/img/#{@colour}-sphere.png"

    mounted: ->
        ## fix the aspect ratio of the canvas
        canvas = @$refs.canvas
        rect   = canvas.getBoundingClientRect()
        width  = rect.width  * 2
        height = rect.height * 2
        canvas.setAttribute 'width',  width
        canvas.setAttribute 'height', height

        ctx       = canvas.getContext "2d"
        imageData = ctx.getImageData 0, 0, width, height
        pixels    = imageData.data

        ## generate noise over the background
        i      = 0
        len    = pixels.length
        random = Math.random
        while i < len
            level = random() * 256
            pixels[i++] = pixels[i++] = pixels[i++] = level
            pixels[i++] = 150 # alpha

        ctx.putImageData imageData, 0, 0

        ## set up animation timer
        setInterval @shiftShape, 10000

    computed:
        sizes: ->
            left:   @x
            bottom: @y
            width:  "#{@size}px"
            height: "#{@size}px"
            backgroundImage: "url(#{@bg}}"

        canvStyle: ->
            top:  @canvY
            left: @canvX

    methods:
        rand: (from, to, suff = "%")->
            range = Math.abs to - from
            rand  = Math.floor(Math.random() * range) + from
            "#{rand}#{suff}"

        shiftShape: ->
            @x = @rand @fromX, @tillX, '%'
            @y = @rand @fromY, @tillY, '%'
            @canvX = @rand -@size, 0, 'px'
            @canvY = @rand -@size, 0, 'px'

